export const communityTranslations = {
  fr: {
    title: "Communauté médicale",
    subtitle: "Échangez et partagez avec vos confrères",
    skipToContent: "Aller au contenu",
    navigation: {
      dashboard: "Tableau de bord",
      back: "Retour"
    },
    stats: {
      discussions: "discussions",
      active: "Actif",
      members: "membres",
      posts: "publications"
    },
    actions: {
      newPost: "Nouveau post",
      newPostShort: "Post",
      reply: "Répondre",
      like: "J'aime",
      share: "Partager",
      report: "Signaler",
      edit: "Modifier",
      delete: "Supprimer",
      createFirst: "Créer la première discussion"
    },
    post: {
      title: "Titre",
      content: "Contenu",
      category: "Catégorie",
      type: "Type de publication",
      tags: "Tags",
      pinned: "Épinglé",
      locked: "Verrouillé",
      resolved: "Résolu",
      views: "vues",
      replies: "réponses",
      likes: "j'aime"
    },
    postTypes: {
      discussion: "Discussion",
      question: "Question",
      caseStudy: "Cas clinique",
      all: "Tous"
    },
    categories: {
      general: "Général",
      cardiology: "Cardiologie",
      neurology: "Neurologie",
      pediatrics: "Pédiatrie",
      surgery: "Chirurgie",
      emergency: "Urgences",
      pharmacy: "Pharmacie",
      radiology: "Radiologie",
      specialties: "Spécialités"
    },
    profile: {
      activeProfile: "Profil actif"
    },
    create: {
      title: "Créer une nouvelle discussion",
      description: "Partagez une question, un cas clinique ou une réflexion avec la communauté",
      titlePlaceholder: "Titre de votre discussion...",
      questionPlaceholder: "Posez votre question clinique...",
      casePlaceholder: "Présentez votre cas clinique...",
      contentPlaceholder: "Décrivez votre sujet, partagez votre expérience...",
      questionContentPlaceholder: "Décrivez votre question, le contexte clinique...",
      caseContentPlaceholder: "Présentez le cas : anamnèse, examen clinique, examens complémentaires...",
      selectCategory: "Choisissez une catégorie",
      selectType: "Type de publication",
      addTags: "Ajouter des tags (optionnel)",
      submit: "Publier",
      askQuestion: "Poser la question",
      shareCase: "Partager le cas",
      cancel: "Annuler"
    },
    replies: {
      title: "Réponses",
      add: "Ajouter une réponse",
      placeholder: "Votre réponse...",
      detailedPlaceholder: "Partagez votre expertise, expérience ou point de vue...",
      yourReply: "Votre réponse",
      submit: "Envoyer",
      noReplies: "Aucune réponse pour le moment",
      firstReply: "Soyez le premier à répondre !"
    },
    user: {
      unknown: "Utilisateur inconnu",
      roleUndefined: "Rôle non défini"
    },
    loginToVote: "Vous devez être connecté pour voter",
    search: {
      placeholder: "Rechercher dans les discussions...",
      search: "Rechercher",
      filters: "Filtres",
      clear: "Effacer",
      category: "Catégorie",
      allCategories: "Toutes les catégories",
      sort: "Tri",
      byType: "Par type",
      byCategory: "Par catégorie",
      byStatus: "Par statut",
      resolved: "Résolu",
      unresolved: "Non résolu",
      withTags: "Avec tags"
    },
    report: {
      title: "Signaler ce contenu",
      description: "Aidez-nous à maintenir une communauté sûre et respectueuse en signalant le contenu inapproprié.",
      reasonLabel: "Raison du signalement",
      reasonPlaceholder: "Sélectionnez une raison",
      descriptionLabel: "Description (optionnel)",
      descriptionPlaceholder: "Ajoutez des détails sur le problème...",
      cancel: "Annuler",
      submit: "Signaler",
      submitting: "Envoi...",
      loginRequired: "Vous devez être connecté pour signaler du contenu",
      selectReason: "Veuillez sélectionner une raison",
      success: "Signalement envoyé. Notre équipe va examiner ce contenu.",
      error: "Erreur lors du signalement",
      reasons: {
        spam: "Spam ou publicité",
        harassment: "Harcèlement ou intimidation",
        inappropriate: "Contenu inapproprié",
        misinformation: "Désinformation médicale",
        privacy: "Violation de confidentialité patient",
        other: "Autre"
      }
    },
    searchBar: {
      postType: "Type de post",
      allTypes: "Tous les types",
      questions: "Questions",
      discussions: "Discussions",
      caseStudy: "Cas cliniques",
      announcements: "Annonces",
      sortBy: "Trier par",
      mostRecent: "Plus récent",
      mostPopular: "Plus populaire",
      answered: "Répondu",
      categoryLabel: "Catégorie",
      typeLabel: "Type"
    },
    moderation: {
      pin: "Épingler",
      unpin: "Désépingler",
      lock: "Verrouiller",
      unlock: "Déverrouiller",
      hide: "Masquer",
      show: "Afficher",
      delete: "Supprimer",
      moderate: "Modérer",
      moderator: "Modérateur"
    },
    messages: {
      postCreated: "Discussion créée avec succès !",
      voteError: "Erreur lors du vote",
      cannotVoteOwnContent: "Vous ne pouvez pas voter pour votre propre contenu",
      postDeleted: "Post supprimé",
      postPinned: "Post épinglé",
      postUnpinned: "Post désépinglé",
      postLocked: "Post verrouillé",
      postUnlocked: "Post déverrouillé",
      replyAdded: "Réponse ajoutée !",
      likeSaved: "J'aime enregistré",
      likeRemoved: "J'aime retiré",
      loginRequired: "Vous devez être connecté",
      fillAllFields: "Veuillez remplir tous les champs",
      fillFields: "Veuillez remplir les champs suivants : {{fields}}",
    fields: { title: "titre", content: "contenu", category: "catégorie" },
      errorLoading: "Erreur lors du chargement",
      errorCreating: "Erreur lors de la création",
      errorDeleting: "Erreur lors de la suppression",
      loadingCommunity: "Chargement de la communauté...",
      loadingDiscussions: "Impossible de charger les discussions",
      replyPlaceholder: "Veuillez saisir votre réponse"
    },
    filters: {
      all: "Toutes",
      recent: "Récentes",
      popular: "Populaires",
      unanswered: "Sans réponse",
      resolved: "Résolues",
      pinned: "Épinglées",
      hot: "Tendance",
      new: "Nouveau",
      top: "Top"
    },
    trending: {
      title: "Sujets Tendance",
      topics: "Sujets populaires cette semaine"
    },
    topContributors: {
      title: "Top Contributeurs",
      points: "points"
    },
    hero: {
      title: "Communauté Médicale",
      subtitle: "Échangez avec vos confrères",
      activeCommunity: "Communauté active"
    },
    indicators: {
      hot: "Tendance",
      new: "Nouveau",
      rising: "En hausse"
    },
    empty: {
      noPosts: "Aucune discussion trouvée",
      noPostsDesc: "Soyez le premier à démarrer une discussion !",
      noResults: "Aucun résultat",
      noResultsDesc: "Essayez de modifier vos critères de recherche"
    },
    loadMore: "Charger plus",
    tagInput: {
      hint: "Tapez Entrée ou virgule pour ajouter un tag. Les tags aident à catégoriser votre discussion."
    },
    anonymizer: {
      title: "Vérification de confidentialité",
      validated: "Contenu validé",
      risksDetected: "{{count}} risque(s) détecté(s)",
      hideDetails: "Masquer les détails",
      showDetails: "Afficher les détails",
      warningTitle: "Attention :",
      warningText: "Votre contenu semble contenir des informations permettant d'identifier un patient. Veuillez les anonymiser avant de publier pour respecter la confidentialité médicale.",
      detectedElements: "Éléments détectés :",
      anonymize: "Anonymiser",
      riskName: "Nom possible",
      riskDate: "Date",
      riskId: "Identifiant",
      riskAge: "Âge spécifique",
      riskLocation: "Localisation",
      replaceName: "M. [ANONYME]",
      replaceAge: "âgé de [XX] ans",
      replaceLocation: "domicilié à [VILLE]",
      replaceDefault: "[ANONYMISÉ]",
      tipsTitle: "Conseils d'anonymisation :",
      tip1: "Remplacez les noms par \"M./Mme [ANONYME]\" ou \"Patient de [service]\"",
      tip2: "Utilisez des âges approximatifs (\"cinquantenaire\", \"jeune adulte\")",
      tip3: "Évitez les dates précises, préférez \"il y a quelques jours\"",
      tip4: "Ne mentionnez pas d'identifiants (IPP, IEP, NSS)"
    },
    richText: {
      invalidUrl: "URL invalide. Utilisez uniquement des liens HTTP/HTTPS valides.",
      invalidImageUrl: "URL d'image invalide. Utilisez uniquement des images JPG, PNG, GIF ou WebP avec des liens HTTP/HTTPS.",
    },
    reputation: {
      legend: 'Légende',
      mentor: 'Mentor',
      expert: 'Expert',
      contributor: 'Contributeur',
      beginner: 'Débutant',
    }
  },
  en: {
    title: "Medical Community",
    subtitle: "Exchange and share with your colleagues",
    skipToContent: "Skip to content",
    navigation: {
      dashboard: "Dashboard",
      back: "Back"
    },
    stats: {
      discussions: "discussions",
      active: "Active",
      members: "members",
      posts: "posts"
    },
    actions: {
      newPost: "New post",
      newPostShort: "Post",
      reply: "Reply",
      like: "Like",
      share: "Share",
      report: "Report",
      edit: "Edit",
      delete: "Delete",
      createFirst: "Create first discussion"
    },
    post: {
      title: "Title",
      content: "Content",
      category: "Category",
      type: "Post type",
      tags: "Tags",
      pinned: "Pinned",
      locked: "Locked",
      resolved: "Resolved",
      views: "views",
      replies: "replies",
      likes: "likes"
    },
    postTypes: {
      discussion: "Discussion",
      question: "Question",
      caseStudy: "Clinical case",
      all: "All"
    },
    categories: {
      general: "General",
      cardiology: "Cardiology",
      neurology: "Neurology",
      pediatrics: "Pediatrics",
      surgery: "Surgery",
      emergency: "Emergency",
      pharmacy: "Pharmacy",
      radiology: "Radiology",
      specialties: "Specialties"
    },
    profile: {
      activeProfile: "Active profile"
    },
    create: {
      title: "Create new discussion",
      description: "Share a question, clinical case or thought with the community",
      titlePlaceholder: "Title of your discussion...",
      contentPlaceholder: "Share your question or thought...",
      selectCategory: "Select a category",
      selectType: "Post type",
      addTags: "Add tags (optional)",
      submit: "Publish",
      cancel: "Cancel"
    },
    replies: {
      title: "Replies",
      add: "Add a reply",
      placeholder: "Your reply...",
      detailedPlaceholder: "Share your expertise, experience or point of view...",
      yourReply: "Your reply",
      submit: "Send",
      noReplies: "No replies yet",
      firstReply: "Be the first to reply!"
    },
    user: {
      unknown: "Unknown user",
      roleUndefined: "Role undefined"
    },
    loginToVote: "You must be logged in to vote",
    search: {
      placeholder: "Search in discussions...",
      search: "Search",
      filters: "Filters",
      clear: "Clear",
      category: "Category",
      allCategories: "All categories",
      sort: "Sort",
      byType: "By type",
      byCategory: "By category",
      byStatus: "By status",
      resolved: "Resolved",
      unresolved: "Unresolved",
      withTags: "With tags"
    },
    report: {
      title: "Report this content",
      description: "Help us maintain a safe and respectful community by reporting inappropriate content.",
      reasonLabel: "Reason for reporting",
      reasonPlaceholder: "Select a reason",
      descriptionLabel: "Description (optional)",
      descriptionPlaceholder: "Add details about the problem...",
      cancel: "Cancel",
      submit: "Report",
      submitting: "Sending...",
      loginRequired: "You must be logged in to report content",
      selectReason: "Please select a reason",
      success: "Report sent. Our team will review this content.",
      error: "Error reporting content",
      reasons: {
        spam: "Spam or advertising",
        harassment: "Harassment or intimidation",
        inappropriate: "Inappropriate content",
        misinformation: "Medical misinformation",
        privacy: "Patient confidentiality violation",
        other: "Other"
      }
    },
    searchBar: {
      postType: "Post type",
      allTypes: "All types",
      questions: "Questions",
      discussions: "Discussions",
      caseStudy: "Clinical cases",
      announcements: "Announcements",
      sortBy: "Sort by",
      mostRecent: "Most recent",
      mostPopular: "Most popular",
      answered: "Answered",
      categoryLabel: "Category",
      typeLabel: "Type"
    },
    moderation: {
      pin: "Pin",
      unpin: "Unpin",
      lock: "Lock",
      unlock: "Unlock",
      hide: "Hide",
      show: "Show",
      delete: "Delete",
      moderate: "Moderate",
      moderator: "Moderator"
    },
    messages: {
      postCreated: "Discussion created successfully!",
      voteError: "Error voting",
      cannotVoteOwnContent: "You cannot vote on your own content",
      postDeleted: "Post deleted",
      postPinned: "Post pinned",
      postUnpinned: "Post unpinned",
      postLocked: "Post locked",
      postUnlocked: "Post unlocked",
      replyAdded: "Reply added!",
      likeSaved: "Like saved",
      likeRemoved: "Like removed",
      loginRequired: "You must be logged in",
      fillAllFields: "Please fill all fields",
      fillFields: "Please fill the following fields: {{fields}}",
    fields: { title: "title", content: "content", category: "category" },
      errorLoading: "Error loading",
      errorCreating: "Error creating",
      errorDeleting: "Error deleting"
    },
    filters: {
      all: "All",
      recent: "Recent",
      popular: "Popular",
      unanswered: "Unanswered",
      resolved: "Resolved",
      pinned: "Pinned",
      hot: "Hot",
      new: "New",
      top: "Top"
    },
    trending: {
      title: "Trending Topics",
      topics: "Popular topics this week"
    },
    topContributors: {
      title: "Top Contributors",
      points: "points"
    },
    hero: {
      title: "Medical Community",
      subtitle: "Exchange with your colleagues",
      activeCommunity: "Active community"
    },
    indicators: {
      hot: "Hot",
      new: "New",
      rising: "Rising"
    },
    empty: {
      noPosts: "No discussions found",
      noPostsDesc: "Be the first to start a discussion!",
      noResults: "No results",
      noResultsDesc: "Try modifying your search criteria"
    },
    loadMore: "Load more",
    tagInput: {
      hint: "Press Enter or comma to add a tag. Tags help categorize your discussion."
    },
    anonymizer: {
      title: "Privacy check",
      validated: "Content validated",
      risksDetected: "{{count}} risk(s) detected",
      hideDetails: "Hide details",
      showDetails: "Show details",
      warningTitle: "Warning:",
      warningText: "Your content appears to contain patient-identifying information. Please anonymize before posting to respect medical confidentiality.",
      detectedElements: "Detected elements:",
      anonymize: "Anonymize",
      riskName: "Possible name",
      riskDate: "Date",
      riskId: "Identifier",
      riskAge: "Specific age",
      riskLocation: "Location",
      replaceName: "Mr. [ANONYMOUS]",
      replaceAge: "aged [XX] years",
      replaceLocation: "residing in [CITY]",
      replaceDefault: "[ANONYMIZED]",
      tipsTitle: "Anonymization tips:",
      tip1: "Replace names with \"Mr./Mrs. [ANONYMOUS]\" or \"Patient from [department]\"",
      tip2: "Use approximate ages (\"fifty-something\", \"young adult\")",
      tip3: "Avoid specific dates, prefer \"a few days ago\"",
      tip4: "Do not mention identifiers (IPP, IEP, SSN)"
    },
    richText: {
      invalidUrl: "Invalid URL. Use only valid HTTP/HTTPS links.",
      invalidImageUrl: "Invalid image URL. Use only JPG, PNG, GIF or WebP images with HTTP/HTTPS links.",
    },
    reputation: {
      legend: 'Legend',
      mentor: 'Mentor',
      expert: 'Expert',
      contributor: 'Contributor',
      beginner: 'Beginner',
    }
  },
  es: {
    title: "Comunidad Médica",
    subtitle: "Intercambia y comparte con tus colegas",
    skipToContent: "Ir al contenido",
    navigation: {
      dashboard: "Panel de control",
      back: "Atrás"
    },
    stats: {
      discussions: "discusiones",
      active: "Activo",
      members: "miembros",
      posts: "publicaciones"
    },
    actions: {
      newPost: "Nueva publicación",
      newPostShort: "Post",
      reply: "Responder",
      like: "Me gusta",
      share: "Compartir",
      report: "Reportar",
      edit: "Editar",
      delete: "Eliminar",
      createFirst: "Crear primera discusión"
    },
    post: {
      title: "Título",
      content: "Contenido",
      category: "Categoría",
      type: "Tipo de publicación",
      tags: "Etiquetas",
      pinned: "Fijado",
      locked: "Bloqueado",
      resolved: "Resuelto",
      views: "vistas",
      replies: "respuestas",
      likes: "me gusta"
    },
    postTypes: {
      discussion: "Discusión",
      question: "Pregunta",
      caseStudy: "Caso clínico",
      all: "Todos"
    },
    categories: {
      general: "General",
      cardiology: "Cardiología",
      neurology: "Neurología",
      pediatrics: "Pediatría",
      surgery: "Cirugía",
      emergency: "Emergencias",
      pharmacy: "Farmacia",
      radiology: "Radiología",
      specialties: "Especialidades"
    },
    profile: {
      activeProfile: "Perfil activo"
    },
    create: {
      title: "Crear nueva discusión",
      description: "Comparte una pregunta, caso clínico o reflexión con la comunidad",
      titlePlaceholder: "Título de tu discusión...",
      contentPlaceholder: "Comparte tu pregunta o reflexión...",
      selectCategory: "Seleccionar una categoría",
      selectType: "Tipo de publicación",
      addTags: "Agregar etiquetas (opcional)",
      submit: "Publicar",
      cancel: "Cancelar"
    },
    replies: {
      title: "Respuestas",
      add: "Agregar una respuesta",
      placeholder: "Tu respuesta...",
      detailedPlaceholder: "Comparte tu experiencia, conocimiento o punto de vista...",
      yourReply: "Tu respuesta",
      submit: "Enviar",
      noReplies: "No hay respuestas aún",
      firstReply: "¡Sé el primero en responder!"
    },
    user: {
      unknown: "Usuario desconocido",
      roleUndefined: "Rol no definido"
    },
    loginToVote: "Debes iniciar sesión para votar",
    search: {
      placeholder: "Buscar en las discusiones...",
      search: "Buscar",
      filters: "Filtros",
      clear: "Limpiar",
      category: "Categoría",
      allCategories: "Todas las categorías",
      sort: "Ordenar",
      byType: "Por tipo",
      byCategory: "Por categoría",
      byStatus: "Por estado",
      resolved: "Resuelto",
      unresolved: "Sin resolver",
      withTags: "Con etiquetas"
    },
    report: {
      title: "Reportar este contenido",
      description: "Ayúdanos a mantener una comunidad segura y respetuosa reportando contenido inapropiado.",
      reasonLabel: "Razón del reporte",
      reasonPlaceholder: "Seleccione una razón",
      descriptionLabel: "Descripción (opcional)",
      descriptionPlaceholder: "Añada detalles sobre el problema...",
      cancel: "Cancelar",
      submit: "Reportar",
      submitting: "Enviando...",
      loginRequired: "Debe estar conectado para reportar contenido",
      selectReason: "Por favor seleccione una razón",
      success: "Reporte enviado. Nuestro equipo revisará este contenido.",
      error: "Error al reportar contenido",
      reasons: {
        spam: "Spam o publicidad",
        harassment: "Acoso o intimidación",
        inappropriate: "Contenido inapropiado",
        misinformation: "Desinformación médica",
        privacy: "Violación de confidencialidad del paciente",
        other: "Otro"
      }
    },
    searchBar: {
      postType: "Tipo de publicación",
      allTypes: "Todos los tipos",
      questions: "Preguntas",
      discussions: "Discusiones",
      caseStudy: "Casos clínicos",
      announcements: "Anuncios",
      sortBy: "Ordenar por",
      mostRecent: "Más reciente",
      mostPopular: "Más popular",
      answered: "Respondido",
      categoryLabel: "Categoría",
      typeLabel: "Tipo"
    },
    moderation: {
      pin: "Fijar",
      unpin: "Desfijar",
      lock: "Bloquear",
      unlock: "Desbloquear",
      hide: "Ocultar",
      show: "Mostrar",
      delete: "Eliminar",
      moderate: "Moderar",
      moderator: "Moderador"
    },
    messages: {
      postCreated: "¡Discusión creada exitosamente!",
      voteError: "Error al votar",
      cannotVoteOwnContent: "No puedes votar tu propio contenido",
      postDeleted: "Publicación eliminada",
      postPinned: "Publicación fijada",
      postUnpinned: "Publicación desfijada",
      postLocked: "Publicación bloqueada",
      postUnlocked: "Publicación desbloqueada",
      replyAdded: "¡Respuesta agregada!",
      likeSaved: "Me gusta guardado",
      likeRemoved: "Me gusta eliminado",
      loginRequired: "Debes estar conectado",
      fillAllFields: "Por favor completa todos los campos",
      fillFields: "Por favor complete los siguientes campos: {{fields}}",
    fields: { title: "título", content: "contenido", category: "categoría" },
      errorLoading: "Error al cargar",
      errorCreating: "Error al crear",
      errorDeleting: "Error al eliminar"
    },
    filters: {
      all: "Todas",
      recent: "Recientes",
      popular: "Populares",
      unanswered: "Sin respuesta",
      resolved: "Resueltas",
      pinned: "Fijadas",
      hot: "Tendencia",
      new: "Nuevo",
      top: "Top"
    },
    trending: {
      title: "Temas Tendencia",
      topics: "Temas populares esta semana"
    },
    topContributors: {
      title: "Top Contribuidores",
      points: "puntos"
    },
    hero: {
      title: "Comunidad Médica",
      subtitle: "Intercambia con tus colegas",
      activeCommunity: "Comunidad activa"
    },
    indicators: {
      hot: "Tendencia",
      new: "Nuevo",
      rising: "En aumento"
    },
    empty: {
      noPosts: "No se encontraron discusiones",
      noPostsDesc: "¡Sé el primero en iniciar una discusión!",
      noResults: "Sin resultados",
      noResultsDesc: "Intenta modificar tus criterios de búsqueda"
    },
    loadMore: "Cargar más",
    tagInput: {
      hint: "Presiona Enter o coma para agregar una etiqueta. Las etiquetas ayudan a categorizar tu discusión."
    },
    anonymizer: {
      title: "Verificación de privacidad",
      validated: "Contenido validado",
      risksDetected: "{{count}} riesgo(s) detectado(s)",
      hideDetails: "Ocultar detalles",
      showDetails: "Mostrar detalles",
      warningTitle: "Atención:",
      warningText: "Su contenido parece contener información que identifica a un paciente. Por favor, anonimice antes de publicar para respetar la confidencialidad médica.",
      detectedElements: "Elementos detectados:",
      anonymize: "Anonimizar",
      riskName: "Posible nombre",
      riskDate: "Fecha",
      riskId: "Identificador",
      riskAge: "Edad específica",
      riskLocation: "Ubicación",
      replaceName: "Sr. [ANÓNIMO]",
      replaceAge: "de [XX] años",
      replaceLocation: "residente en [CIUDAD]",
      replaceDefault: "[ANONIMIZADO]",
      tipsTitle: "Consejos de anonimización:",
      tip1: "Reemplace los nombres por \"Sr./Sra. [ANÓNIMO]\" o \"Paciente de [servicio]\"",
      tip2: "Use edades aproximadas (\"cincuentón\", \"adulto joven\")",
      tip3: "Evite las fechas precisas, prefiera \"hace unos días\"",
      tip4: "No mencione identificadores (IPP, IEP, NSS)"
    },
    richText: {
      invalidUrl: "URL no válida. Use solo enlaces HTTP/HTTPS válidos.",
      invalidImageUrl: "URL de imagen no válida. Use solo imágenes JPG, PNG, GIF o WebP con enlaces HTTP/HTTPS.",
    },
    reputation: {
      legend: 'Leyenda',
      mentor: 'Mentor',
      expert: 'Experto',
      contributor: 'Contribuidor',
      beginner: 'Principiante',
    }
  }
};